export * from './packages/affix/index.js';
export * from './packages/alert/index.js';
export * from './packages/link/index.js';
export * from './packages/button/index.js';
export * from './packages/attention/index.js';
export * from './packages/badge/index.js';
export * from './packages/box/index.js';
export * from './packages/breadcrumbs/index.js';
export * from './packages/card/index.js';
export * from './packages/expandable/index.js';
export * from './packages/pill/index.js';
export * from './packages/select/index.js';
export * from './packages/textfield/index.js';
export * from './packages/modal/index.js';
export * from './packages/toast/index.js';
export * from './packages/datepicker/index.js';
export * from './packages/switch/index.js';
export * from './packages/combobox/index.js';
Promise.all([customElements.whenDefined('w-affix'),customElements.whenDefined('w-alert'),customElements.whenDefined('w-link'),customElements.whenDefined('w-button'),customElements.whenDefined('w-attention'),customElements.whenDefined('w-badge'),customElements.whenDefined('w-box'),customElements.whenDefined('w-breadcrumbs'),customElements.whenDefined('w-card'),customElements.whenDefined('w-expandable'),customElements.whenDefined('w-pill'),customElements.whenDefined('w-select'),customElements.whenDefined('w-textfield'),customElements.whenDefined('w-modal-footer'),customElements.whenDefined('w-modal-header'),customElements.whenDefined('w-modal'),customElements.whenDefined('w-toast-container'),customElements.whenDefined('w-datepicker'),customElements.whenDefined('w-switch'),customElements.whenDefined('w-combobox')]).then(() => {
    performance.mark('vend/pc-design-system/warp-elements-loaded');
});